import styled from 'styled-components';

const Sm = styled.div`
    font-size: .9rem;
`;

export default Sm;